import { useBlocker } from '@tanstack/react-router';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';

export function CommunicationUnsavedGuard({ dirty }: { dirty: boolean }) {
  const blocker = useBlocker({
    shouldBlockFn: () => dirty,
    disabled: !dirty,
    enableBeforeUnload: dirty,
    withResolver: true,
  });
  const blocked = dirty && blocker.status === 'blocked';
  return (
    <Dialog
      open={blocked}
      onOpenChange={(open) => !open && blocker.status === 'blocked' && blocker.reset()}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Ungespeicherte Änderungen</DialogTitle>
          <DialogDescription>
            Ihre Änderungen sind noch nicht gespeichert. Möchten Sie weiterarbeiten oder die Seite
            trotzdem verlassen?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="ghost"
            className="min-h-11"
            onClick={() => blocker.status === 'blocked' && blocker.reset()}
          >
            Weiter bearbeiten
          </Button>
          <Button
            type="button"
            variant="destructive"
            className="min-h-11"
            onClick={() => blocker.status === 'blocked' && blocker.proceed()}
          >
            Verwerfen und wechseln
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
